<template>
  <v-avatar :size="size" :color="avatarColor" :title="avatarTitle" v-bind="$attrs" v-on="$listeners">
    <v-img v-if="avatarSrc" :src="avatarSrc"/>
    <span v-else :class="textStyle" v-text="initials"></span>
  </v-avatar>
</template>

<script>
export default {
  name: "CrmAvatar",
  props: {
    value: {
      type: Object,
      required: true
    },
    src: {
    },
    property: {
      type: String,
      default: 'picture'
    },
    assets: {
      type: String
    },
    size: {
      type: Number,
      default: 28
    },
    color: {
      type: String,
      default: 'primary'
    },
    textClass: {
      type: String,
      default: 'white--text'
    }
  },
  computed: {
    assetsPath () {
      return this.assets || `${process.env.VUE_APP_API}/${this.$crm.tenant}/v1/content/assets`
    },
    imageName() {
      return this.value && this.value[this.property]
    },
    avatarSrc () {
      if(this.src !== undefined) {
        return this.src
      }
      const tenant = this.$crm.tenant
      const img = this.imageName
      if(tenant && img) {
        return `${this.assetsPath}/${img}?variant=thumbnail`
      }
      return null
    },
    avatarColor () {
      return this.avatarSrc ? '#ffffff' : this.color
    },
    avatarTitle () {
      return this.value.name
    },
    textStyle () {
      return this.size < 30 ? ['text-body-2', this.textClass] : (this.size > 100 ? ['text-h3', this.textClass] : ['text-body-1', this.textClass])
    },
    initials () {
      const value = this.value
      if (value.initials) {
        return value.initials
      }
      if (value.firstName && value.lastName) {
        return value.firstName[0].toUpperCase() + value.lastName[0].toUpperCase()
      }
      if (value.name) {
        const name = value.name.replace(/[^0-9a-zéåäöü ]/gi, '').trim()
        const names = name.split(' ', 2)
        if (names.length > 1) {
          const firstName = names[0] || ''
          const lastName = names[1]  || ''
          return firstName[0].toUpperCase() + lastName[0].toUpperCase()
        }
        if (name.length > 1) {
          return name.substring(0, 2).toUpperCase()
        }
        return name.toUpperCase()
      }
      return '?'
    },
  },
}
</script>
